export const motivos = [
    "Dúvidas, sugestões ou problemas com o site",
    "Ajuda com o Clube Do Aluno - Estácio",
    "Ajuda com o MeuCupom Devolve",
    "Parcerias comerciais",
];